import { MemoryUnits } from '@cast/shared-types';
export const openPlanDialogQueryKey = 'openPlan';

export const DEFAULT_MEMORY_UNIT: MemoryUnits = 'GiB';
export const DEFAULT_CPU_UNIT = 'CPU';

export const REBALANCING_TOOLTIPS = {
  PREDICTED_SAVINGS:
    'Estimated cost reduction based on the proposed rebalanced configuration.',
  ACHIEVED_SAVINGS:
    'Actual cost reduction after the plan was executed, compared to the previous configuration.',
  CPU_UTILIZATION:
    'Percentage of total CPU capacity used by workloads before and after rebalancing.',
  MEMORY_UTILIZATION:
    'Percentage of total memory capacity used by workloads before and after rebalancing.',
};
